import { HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpInterceptor } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          this.convertDates(event.body);
        }
      }
    }));
  }

  private convertDates(object: any) {
    const dateOnlyRegex = /^Date\('(\d{4})-(\d{2})-(\d{2})'\)$/;
    const dateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)$/;
    const utcDateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/;
    const timeOnlyRegex = /^(\d{2}):(\d{2})$/;

    if (!object || typeof object !== 'object') {
      return;
    }

    if (Array.isArray(object)) {
      for (const item of object) {
        this.convertDates(item);
      }
      return;
    }

    for (const key in object) {
      const value = object[key];

      if (typeof value === 'string') {
        let match;
        if ((match = dateRegex.exec(value))) {
          // yyyy-MM-ddTHH:mm:ss(.sss)
          const [_, year, month, day, hour, min, sec] = match;
          object[key] = new Date(
            Number(year),
            Number(month) - 1,
            Number(day),
            Number(hour),
            Number(min),
            Math.floor(Number(sec))
          );
        } else if ((match = utcDateRegex.exec(value))) {
          // yyyy-MM-ddTHH:mm:ss(.sss)Z
          const [_, year, month, day, hour, min, sec] = match;

          if (Number(hour) == 0 && Number(min) == 0 && Math.floor(Number(sec)) == 0) {
            object[key] = new Date(
                Number(year),
                Number(month) - 1,
                Number(day)
            )
          } else {
            object[key] = new Date(
              Date.UTC(
                Number(year),
                Number(month) - 1,
                Number(day),
                Number(hour),
                Number(min),
                Math.floor(Number(sec))
              )
            );
          }
        } else if ((match = dateOnlyRegex.exec(value))) {
          // yyyy-MM-dd
          const [_, year, month, day] = match;
          object[key] = new Date(
            Date.UTC(
              Number(year),
              Number(month) - 1,
              Number(day) + 1
            )
          );
        } else if ((match = timeOnlyRegex.exec(value))) {
          // HH:mm
          const [_, hour, min] = match;
          object[key] = new Date(0, 0, 0, Number(hour), Number(min));
        }
      } else if (typeof value === 'object' && value !== null) {
        this.convertDates(value);
      }
    }
  }
}
